import { NgClass } from '@angular/common';
import {
  Component,
  computed,
  ElementRef,
  inject,
  output,
  signal,
  viewChild,
  effect,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AiVoiceService } from '@services';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AiTextService } from '../../core/services/ai-text.service';

@Component({
  selector: 'bo-chat',
  templateUrl: './chat.html',
  standalone: true,
  imports: [AngularSvgIconModule, FormsModule, NgClass],
})
export class Chat {
  textArea = viewChild<ElementRef<HTMLTextAreaElement>>('textArea');
  closeChat = output();

  #aiText = inject(AiTextService);
  aiVoice = inject(AiVoiceService);

  constructor() {
    effect(
      () => {
        this.userInput.set('');
        if (this.aiVoice.question() && this.aiVoice.question() !== '') {
          this.placeholder.set(this.aiVoice.question());
        }
      },
      { allowSignalWrites: true },
    );
  }

  userInput = signal('');
  placeholder = signal('Ask me anything!');

  answer = computed(() => this.#aiText.answer() || this.aiVoice.answer());
  showAnswer = computed(
    () => this.#aiText.answer().length > 0 || this.aiVoice.answer().length > 0,
  );

  idle = computed(() => this.#aiText.idle() || this.aiVoice.idle());

  sendMessage() {
    this.#aiText.sendMessage(this.userInput());
    this.placeholder.set(this.userInput());
    this.userInput.set('');
    const textarea = this.textArea().nativeElement;
    textarea.value = '';
    textarea.blur();
    setTimeout(() => textarea?.focus(), 100);
  }

  record() {
    this.aiVoice.record();
  }
}
